import { selectMember } from 'logic/member';
import { selectProduct } from 'logic/product';

export const ProgramIntro = {
  template: `
    <section class="program-intro pb-5">
      <program-nav></program-nav>
      <div class="bg-container-overlay theme-program-overview bg-opaque-md"></div>
      <div class="program-intro-content container">
        <div class="row">
          <div class="col-md-6 text-center">
            <h2 class="theme-program-logo theme-program-logo--dark">
              <span class="text-black">{{ $ctrl.program.name }}</span>
            </h2>
            <p>{{ $ctrl.program.description }}</p>
            <video-player-resumable video-id="$ctrl.program.productMeta.introVideo.brightcoveId">
            </video-player-resumable>
          </div>
        </div>
      </div>
      <button-full-width
        modal-target="#modalRestartProgram"
        ng-if="$ctrl.program.startedAt && ($ctrl.program.daysElapsed >= 0)">
        Restart
      </button-full-width>
      <button-full-width
        modal-target="#modalStartProgram"
        ng-if="!$ctrl.program.startedAt || ($ctrl.program.daysElapsed < 0)">
        <span ng-if="!$ctrl.program.startedAt">
          Start your program
        </span>
        <span ng-if="$ctrl.program.startedAt">
          Your program will start
          <span ng-if="$ctrl.program.daysElapsed <= -2">in {{ -$ctrl.program.daysElapsed }} days</span>
          <span ng-if="$ctrl.program.daysElapsed === -1">tomorrow</span>
        </span>
      </button-full-width>
    </section>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, {});
        this.unsubscribe = connect(this);
      },

      $onDestroy() {
        this.unsubscribe();
      },

      mapState({ member, product }) {
        return {
          member: selectMember(member),
          program: selectProduct(product),
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Program/Intro.js